import React from 'react'
import { Box, TextField, Grid,Slider,ButtonGroup,Button, Typography, FormControl,IconButton, InputLabel, Select, MenuItem ,Accordion, AccordionSummary, AccordionDetails,} from '@mui/material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FormatAlignCenter,FormatAlignLeft,FormatAlignRight,RoundedCorner,FormatSize } from '@mui/icons-material';
import { AlignHorizontalLeft, AlignHorizontalRight, AlignVerticalBottom, AlignVerticalTop } from '@mui/icons-material';

import BlockProps from './common/BlockProps';
function ButtonBlockProperties({ blockId}) {
  const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };
 // Specific handler for padding changes
  const handleButtonPaddingChange = (side, value) => {
    const currentPadding = properties.buttonpadding || { top: 0, right: 0, bottom: 0, left: 0 };
    const newPadding = { ...currentPadding, [side]: parseInt(value) || 0 };
    handlePropertyChange('buttonpadding', newPadding);
  };

  // Specific handler for margin changes
  const handleButtonMarginChange = (side, value) => {
    const currentMargin = properties.buttonmargin || { top: 0, right: 0, bottom: 0, left: 0 };
    const newMargin = { ...currentMargin, [side]: parseInt(value) || 0 };
    handlePropertyChange('buttonmargin', newMargin);
  };
   
  return (
    <>
            <TextField
              fullWidth
              label="Button Text"
              value={properties.text || ''}
              onChange={(e) => handlePropertyChange('text', e.target.value)}
              sx={{ mb: 2 }}
            />
            
            <TextField
              fullWidth
              label="Link URL"
              value={properties.href || ''}
              onChange={(e) => handlePropertyChange('href', e.target.value)}
              sx={{ mb: 2 }}
            />
            <Box>
              <Accordion sx={{ mb: 2,backgroundColor: 'rgba(0, 0, 0, .03)' }}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle1" sx={{ fontWeight: 400 }}>
                  Button Settings
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                 <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                   <FormControl fullWidth size="small">
                        <InputLabel>Font Family</InputLabel>
                        <Select
                          value={properties.fontFamily || 'Arial, sans-serif'}
                          onChange={(e) => handlePropertyChange('fontFamily', e.target.value)}
                          label="Font Family"
                        >
                          <MenuItem value="Arial, sans-serif">Arial</MenuItem>
                          <MenuItem value="Georgia, serif">Georgia</MenuItem>
                          <MenuItem value="'Times New Roman', serif">Times New Roman</MenuItem>
                          <MenuItem value="'Courier New', monospace">Courier New</MenuItem>
                          <MenuItem value="Helvetica, sans-serif">Helvetica</MenuItem>
                          <MenuItem value="'Trebuchet MS', sans-serif">Trebuchet MS</MenuItem>
                        </Select>
                      </FormControl>
                  <Box>
                         <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                            Alignment
                          </Typography>
                          <Box>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'left')}
                              color={properties.textAlign === 'left' ? 'primary' : 'default'}
                            >
                              <FormatAlignLeft />
                            </IconButton>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'center')}
                              color={properties.textAlign === 'center' ? 'primary' : 'default'}
                            >
                              <FormatAlignCenter />
                            </IconButton>
                            <IconButton 
                              onClick={() => handlePropertyChange('textAlign', 'right')}
                              color={properties.textAlign === 'right' ? 'primary' : 'default'}
                            >
                              <FormatAlignRight />
                            </IconButton>
                          
                          </Box>
                       </Box>
                     

                        <Box>
                          <Typography variant="body2" gutterBottom>
                            Font Size
                          </Typography>
                          <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                            <Grid>
                              <FormatSize />
                            </Grid>
                            <Grid size="grow">
                              <Slider
                                value={properties.fontSize || 16}
                                onChange={(e, value) => handlePropertyChange('fontSize', value)}
                                aria-labelledby="input-slider-font-size"
                                step={1}
                                marks
                                max={48}
                                min={10}
                              />
                            </Grid>
                            <Grid>
                              <Typography variant="body2" gutterBottom>
                                {properties.fontSize || 16} px
                              </Typography>
                            </Grid>
                          </Grid>
                        </Box>
                          <Box>
                                      <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                        Font Weight
                                      </Typography>
                                      <ButtonGroup variant="outlined">
                                        <Button 
                                          onClick={() => handlePropertyChange('fontWeight', 'normal')}
                                          variant={properties.fontWeight === 'normal' ? 'contained' : 'outlined'}
                                        >
                                          Normal
                                        </Button>
                                        <Button 
                                          onClick={() => handlePropertyChange('fontWeight', 'bold')}
                                          variant={properties.fontWeight === 'bold' ? 'contained' : 'outlined'}
                                        >
                                          Bold
                                        </Button>
                                        <Button 
                                          onClick={() => handlePropertyChange('fontWeight', 'lighter')}
                                          variant={properties.fontWeight === 'lighter' ? 'contained' : 'outlined'}
                                        >
                                          Light
                                        </Button>
                                      </ButtonGroup>
                                    </Box>
                                <Box>
                                      <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                        Width
                                      </Typography>
                                      <ButtonGroup variant="outlined">
                                        <Button 
                                          onClick={() => handlePropertyChange('display', 'block')}
                                          variant={properties.display === 'block' ? 'contained' : 'outlined'}
                                        >
                                         Full
                                        </Button>
                                        <Button 
                                          onClick={() => handlePropertyChange('display', 'inline-block')}
                                          variant={properties.display === 'inline-block' ? 'contained' : 'outlined'}
                                        >
                                          Auto
                                        </Button>
                                        
                                      </ButtonGroup>
                                    </Box>
                                    <Box>
                                           <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                                                Border Radius
                                                              </Typography>
                                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                                <Grid>
                                                                    <RoundedCorner />
                                                                </Grid>
                                                                <Grid size="grow">
                                                                <Slider
                                                                    value={properties.buttonborderRadius}
                                                                    onChange={(e) => handlePropertyChange('buttonborderRadius', e.target.value)}
                                                                    aria-labelledby="input-slider-buttonborderradius"
                                                                    step={1}
                                                                    marks
                                                                    max= {20}
                                                                />
                                                                </Grid>
                                                                <Grid>
                                                                    <Typography variant="body2" gutterBottom>
                                                                       {properties.buttonborderRadius} px
                                                                    </Typography>
                                                                </Grid>
                                                                
                                                        </Grid>
                                                            </Box>

                                    <Box>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                      Text Color
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                      <input
                                        type="color"
                                        value={properties.color || '#000000'}
                                        onChange={(e) => handlePropertyChange('color', e.target.value)}
                                        style={{
                                          width: 40,
                                          height: 40,
                                          border: '1px solid #ccc',
                                          borderRadius: 4,
                                          cursor: 'pointer'
                                        }}
                                      />
                                      <TextField
                                        value={properties.color || '#000000'}
                                        onChange={(e) => handlePropertyChange('color', e.target.value)}
                                        size="small"
                                        variant="outlined"
                                        sx={{ flexGrow: 1 }}
                                      />
                                    </Box>
                                  </Box>
                                  <Box>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                      Background Color
                                    </Typography>
                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                      <input
                                        type="color"
                                        value={properties.buttonbackgroundColor || '#000000'}
                                        onChange={(e) => handlePropertyChange('buttonbackgroundColor', e.target.value)}
                                        style={{
                                          width: 40,
                                          height: 40,
                                          border: '1px solid #ccc',
                                          borderRadius: 4,
                                          cursor: 'pointer'
                                        }}
                                      />
                                      <TextField
                                        value={properties.buttonbackgroundColor || '#000000'}
                                        onChange={(e) => handlePropertyChange('buttonbackgroundColor', e.target.value)}
                                        size="small"
                                        variant="outlined"
                                        sx={{ flexGrow: 1 }}
                                      />
                                    </Box>
                                  </Box>
                                   <Box>
                                              <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                                Padding
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalTop />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonpadding?.top || 0}
                                                    onChange={(e, value) => handleButtonPaddingChange('top', value)}
                                                    aria-labelledby="input-slider-padding-top"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonpadding?.top || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalRight />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonpadding?.right || 0}
                                                    onChange={(e, value) => handleButtonPaddingChange('right', value)}
                                                    aria-labelledby="input-slider-padding-right"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonpadding?.right || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalBottom />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonpadding?.bottom || 0}
                                                    onChange={(e, value) => handleButtonPaddingChange('bottom', value)}
                                                    aria-labelledby="input-slider-padding-bottom"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonpadding?.bottom || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalLeft />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonpadding?.left || 0}
                                                    onChange={(e, value) => handleButtonPaddingChange('left', value)}
                                                    aria-labelledby="input-slider-padding-left"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonpadding?.left || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Box>
                                  
                                            {/* Margin */}
                                            <Box>
                                              <Typography variant="body2" sx={{ mb: 1, fontWeight: 400 }}>
                                                Margin
                                              </Typography>
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalTop />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonmargin?.top || 0}
                                                    onChange={(e, value) => handleButtonMarginChange('top', value)}
                                                    aria-labelledby="input-slider-margin-top"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonmargin?.top || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalRight />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonmargin?.right || 0}
                                                    onChange={(e, value) => handleButtonMarginChange('right', value)}
                                                    aria-labelledby="input-slider-margin-right"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonmargin?.right || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignVerticalBottom />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonmargin?.bottom || 0}
                                                    onChange={(e, value) => handleButtonMarginChange('bottom', value)}
                                                    aria-labelledby="input-slider-margin-bottom"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonmargin?.bottom || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                  
                                              <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                                <Grid>
                                                  <AlignHorizontalLeft />
                                                </Grid>
                                                <Grid size="grow">
                                                  <Slider
                                                    value={properties.buttonmargin?.left || 0}
                                                    onChange={(e, value) => handleButtonMarginChange('left', value)}
                                                    aria-labelledby="input-slider-margin-left"
                                                    step={1}
                                                    marks
                                                    max={80}
                                                    min={0}
                                                  />
                                                </Grid>
                                                <Grid>
                                                  <Typography variant="body2" gutterBottom>
                                                    {properties.buttonmargin?.left || 0} px
                                                  </Typography>
                                                </Grid>
                                              </Grid>
                                            </Box>
                                
                </Box>
              </AccordionDetails>
              </Accordion>
               <BlockProps properties={properties} onPropertyChange={handlePropertyChange} />

            </Box>
           

           
          
          </>
  )
}

export default ButtonBlockProperties